import { RadioButton } from '@deliveryhero/pd-cookbook/components/RadioButton';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Grid } from '@mui/material';

import { RadioGroupProps } from './types';

export function RadioGroup<T>(props: RadioGroupProps<T>) {
  const {
    name,
    value,
    onChange,
    radioProps: RadioButtons,
    editable = true,
    label
  } = props;

  return (
    <>
      {Boolean(label) && (
        <Typography type="title-sm" color="neutral-secondary">
          {label}
        </Typography>
      )}
      <fieldset
        style={{
          minWidth: 0,
          margin: 0,
          padding: 0,
          border: 0,
          display: 'flex',
          gap: '80px'
        }}
        role="radiogroup"
        name={name}
      >
        <Grid container>
          {RadioButtons.map((props) => (
            <Grid item key={props.label} xs={true}>
              <RadioButton
                id={props.label}
                name={props.label}
                disabled={!editable}
                label={props.label}
                onClick={() => onChange(props.value)}
                checked={value === props.value}
              />
            </Grid>
          ))}
        </Grid>
      </fieldset>
    </>
  );
}
